














import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HococoImageSlider extends Vue {

    public currentNumber: number = 0;

    public timer: any = null;

    public images: string[] = [
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mP8/5/hPwMVAeOogaMGjho4auCogSPVQABXljvZ3Sl18AAAAABJRU5ErkJggg==',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mPkZKj6z0BFwDhq4KiBowaOGjhq4Eg1EAARih49qX9b+AAAAABJRU5ErkJggg==',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAH0lEQVR42mOs4rT9z0BFwDhq4KiBowaOGjhq4Eg1EADrpSMBbzImaQAAAABJRU5ErkJggg==',
    ];

    constructor() {
        super();
    }

    get dataLoaded(): boolean {
        return true;
    }

    public startRotation() {
        this.timer = setInterval(this.next, 3000);
    }

    public next() {
        this.currentNumber += 1;
    }

    public prev() {
        this.currentNumber -= 1;
    }

    get currentImage() {
        return this.images[Math.abs(this.currentNumber) % this.images.length];
    }
}
